















































































import { Component, Vue } from "vue-property-decorator";
import { validationMixin } from "vuelidate";
import PreviousPageArrow from "@/components/PreviousPageArrow.vue";
import { required, numeric, minLength } from "vuelidate/lib/validators";
import { namespace } from "vuex-class";
import { DocumentType } from "@/modules/document/types";
import axios from "axios";

const Trn = namespace("trn");
const Document = namespace("document");

@Component({
  metaInfo() {
    return {
      title: "Orba One | Enter Your TRN",
    };
  },
  mixins: [validationMixin],
  components: {
    "previous-page-arrow": PreviousPageArrow,
  },
})
export default class CaptureTrn extends Vue {
  @Trn.Action("setTrn") setTrn!: (trn: string) => void;
  @Document.Getter("getDocumentType") documentType!: string;

  isActive = false;
  trnForm = {
    trn: "",
  };

  async mounted() {
    try {
      if (Vue.prototype.$useAudioInstructions) {
        Vue.prototype.$audioConfigs.stopChooseDocument?.();
        await Vue.prototype.$audioConfigs.playEnterTrn?.();
      }
    } catch (err) {
      console.warn("Audio playback failed:", err);
    }
  }

  submitForm = () => {
    this.setTrn(this.trnForm.trn);
    this.nextStep();
  };

  validations() {
    return {
      trnForm: {
        trn: {
          required,
          numeric,
          minLength: minLength(9),
        },
      },
    };
  }
  nextStep() {
    if (this.documentType) {
      switch (this.documentType) {
        case DocumentType.NATIONALID:
          this.enterTrn();
          this.$router.push({
            name: "chooseNationalId",
            query: this.$route.query,
          });
          break;
        case DocumentType.PASSPORT:
          this.enterTrn();
          this.$router.push({
            name: "capturePassport",
            query: this.$route.query,
          });
          break;
      }
    }
  }
  enterTrn() {
    const params = new URLSearchParams(window.location.search);
    const publicKey = params.get("publicKey");
    const applicantId = params.get("applicantId");
    const magicLink = params.get("magic");
    const progressionStep = 11;

    if ((publicKey && applicantId) || magicLink) {
      axios.put(
        `${process.env.VUE_APP_API_URL}/applicants/${applicantId}/verification-progress-step`,
        {
          publicKey,
          progressionStep,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
    }
  }
}
